module.exports = __webpack_public_path__ + "static/media/juicesDrinks.8395a4bf.webp";